export default "/_next/static/images/background-mobile-e12ba6b4a2bef4fe6d7dffd23cee458b.svg";